interface CandleStickChartProps {
  blockchain?: string;
  contractAddress?: string;
  personaId?: string;
  pool?: string;
  user?: {
    roles?: string[];
  };
}

const CandleStickChart = ({ blockchain, pool }: CandleStickChartProps) => {
  // Default URL when blockchain or contractAddress is not provided
  const defaultUrl =
    "https://www.geckoterminal.com/solana/pools/EGZ7tiLeH62TPV1gL8WwbXGzEPa9zmcpVnnkPKKnrE2U?embed=1&info=0&swaps=0&grayscale=0&light_chart=0";
  // Determine the iframe URL
  const iframeUrl =
    blockchain && pool
      ? `https://www.geckoterminal.com/${blockchain}/pools/${pool}?embed=1&info=0&swaps=0&grayscale=0&light_chart=0`
      : defaultUrl;

  // Show modal if blockchain or contractAddress is missing

  return (
    <div id="chart" className="relative overflow-hidden">
      {/* Top mask */}
      <div></div>

      {/* Iframe */}
      <iframe
        src={iframeUrl}
        width="100%"
        height="400"
        style={{ border: "none", marginTop: "0px", marginBottom: "-40px" }}
        allowFullScreen
        title="DEXTools Chart"
      />

      {/* Bottom mask */}
      <div></div>
    </div>
  );
};

export default CandleStickChart;
